module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapx",
    staticStyle: {
      "border": "#facf10 0px solid",
      "background-image": "url('/static/assets/images/order00.jpg')",
      "background-size": "cover",
      "margin-top": "0em",
      "height": "100vh"
    },
    attrs: {
      "id": "wrapx"
    }
  }, [_c('div', {
    staticClass: "pagerx"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "2em",
      "margin-top": "52vh",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "background": "#ffffff",
      "margin-bottom": "1em",
      "padding": "1em 2em 2em 2em",
      "border-radius": "20px",
      "box-shadow": "10px 25px 30px 0px rgba(148, 146, 148, 0.2)"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/ofe_onugbo.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "2em",
      "background": "#ffffff",
      "opacity": "0.87",
      "border-radius": "20px",
      "padding-bottom": "1em"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/brand002.png"
    }
  }), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("@ the best of the best")])]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "background-color": "#facf10",
      "padding": "0.6em 0.8em",
      "border-radius": "50%"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08f7bd02"}!./src/pages/Home/template.html
// module id = 532
// module chunks = 0